import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem('authToken');
  const user = localStorage.getItem('user');

  const allowTokenAccess = sessionStorage.getItem('allowTokenAccess') === 'true';
  const isTokenAccessRoute = location.pathname.startsWith('/capital-expenditure/new-data');
  const fromTokenSearch = Boolean(location.state?.fromTokenSearch);

  if ((!token || !user)) {
    if ((allowTokenAccess || fromTokenSearch) && isTokenAccessRoute) {
      return children;
    }
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
